<template>
  <div class="client-header">
    <div style="margin: 0 auto;width:1200px;display: flex;justify-content: space-between;">
      <div class="logo">云中快游</div>
      <ul class="nav-list">
        <li
          v-for="(item ,index) in navList"
          :key="index"
          class="userinfo"
          @click.stop="chooiseItem(item,index)"
          :class="{active:index==activeIndex}"
        >
          <span class="btnopen" v-if="item.name"> 
            <!-- <a :href='(item.url == "/recharge" && !user)
             ||(item.url == "/user" && !user) ? "/mobile" : item.url' style="display:inline-block">
              </a> -->
              {{item.name }}
            </span>
          <span class="nav-user" v-else></span>
            <div class="sub-nav" v-if="item.children && item.children.length>0">
              <div class="sub-menu">
                <div v-for="(list,i) in item.children" :key="i" @click.stop="chooiseCh(list,index)">
                  <span v-if="!item.name && user && list.show">
                    <a style="display:inline-block">{{list.name }}</a></span>
                  <span v-if="!item.name && !user && !list.show">{{list.name }}</span>
                  <!-- <span v-if="item.name"> <a :href="list.url" style="display:inline-block">{{list.name }}</a></span> -->
                  <span v-if="item.name">{{list.name }}</span>
                </div>
              </div> 
          </div>
         
        </li>
        <li class="userinfo" :class="{active:same}">
          <span class="btnopen nav-user" >
            <a href="javascript:;" class="cur"></a>
          </span>
            <div class="sub-nav" v-if="!user">
              <div class="sub-inner" >
                <span>
                  <!-- <a style="display:inline-block" href="/mobile" >登录</a> -->
                  <a style="display:inline-block" @click="$router.push('/login')">登录</a>

                </span>
              </div>
            
            </div>
            <div class="sub-nav" v-else>
              <div class="sub-inner" >
                <span><a style="display:inline-block" @click="$router.push('/user')">用户中心</a></span>
                <span><a style="display:inline-block"  @click="$store.dispatch('logout')">退出登录</a></span>
              </div>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex2: '1',
      show1:false,
      navList: [
        {
          name: "首页",
          url: "/"
        },
        {
          name: "充值",
          url: "/recharge"
        },
        {
          name: "客户端",
          url: "/client"
        },
        {
          name: "合作",
          // url: "/Paas",
          children: [
            {
              name: "PaaS 平台",
              url: "/Paas"
            },
            {
              name: "IaaS 平台",
              url: "/Iaas"
            },
            {
              name: "聚宝计划",
              url: "/jubao"
            }
          ]
        },
        {
          name: "关于我们",
          url: "/aboutus"
        },
        // {
        //   name: "",
        //   // url: "/login",
        //   children: [
        //     {
        //       name: "登录",
        //       show: false,
        //       url: "/login"
        //     },
        //     {
        //       name: "用户中心",
        //       show: true,
        //       url: "/user"
        //     },
        //     {
        //       name: "退出登录",
        //       show: true,
        //       url: "/out"
        //     }
        //   ]
        // }
      ],
      activeIndex: 0,
      same: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    $route(to, from) {
      if (to.meta && to.meta.same) {
        this.same = to.meta.same ;
        this.activeIndex = null
      }else{
        this.matchIndex();
        this.same = false
      }
      if (
        (to.path == "/recharge" && !this.user) ||
        (to.path == "/user" && !this.user)
      ) {
        this.$router.push("/mobile");
      }
      if ((this.$route.path == "/user" && this.user)) {
          this.same = true
          this.activeIndex = null
        }
    },
  },
  methods: {
    chooiseItem(item, index) {
      this.activeIndex = index;
      if(!item.url) return;
       if (
        (item.url == "/recharge" && !this.user) ||
        (item.url == "/user" && !this.user)
      ) {
        this.$router.push("/login");
      }
      if (item.url === "/out") {
        this.$store.dispatch("logout");
        return false;
      } else {
        this.$router.push(item.url);
      }
    },
    chooiseCh(item) {
      this.$router.push(item.url);
    },
    
    matchIndex() {
      this.navList.forEach((item, index) => {
        if (item.url === this.$route.path) {
          this.activeIndex = index;
          return;
        }else{
          //  this.activeIndex = -1;
        }
        if (item.children && item.children.length > 0) {
          item.children.forEach(list => {
            if (list.url == this.$route.path) {
              this.activeIndex = index;
              return;
            }else{
              // this.activeIndex = -1;
            }
          });
        }
       
      });
       
    }
  },
  mounted() {
    
    this.matchIndex();
  }
};
</script>

<style lang="scss" >
.client-header {
  @include size(100%, 80px);
  position: fixed;
  top: 0;
  background: rgba(7, 12, 21, 0.85);
  z-index: 100;
  display: flex;

  justify-content: space-between;
  .logo {
    width: 170px;
    height: 50px;
    text-indent: -9999px;
    margin-top: 15px;
    background: url("~assets/img/logo.png") no-repeat ;
    background-size: 100% 100%;
    // margin-left: 10px;
    float: left;
  }
  .nav-list {
    float: right;
  }
  .userinfo{
    transition: height 0.3s ease;
    &:hover{
       .sub-nav{
         display: block;
         animation: topIn .3s linear;
       }
    }
  }
  @keyframes topIn {
    0% { 
      opacity: 0; 
    }
    50% { 
      opacity: 0.5; 
    }
    100% { 
      opacity: 1; 
    }
  }

  .sub-nav {
    display: none;
    position: absolute;
    top: 78px;
    left: 50%;
    width: 110px;
    padding: 6px 0;
    margin-left: -55px;
    border-top: 2px solid #56e3ea;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    z-index: 100;
  }
  .sub-nav span {
    display: block;
    color: #fff;
    font-size: 14px;
    line-height: 34px;
    text-align: center;
  }
  .sub-nav span:hover {
    color: #fff;
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
  }
  ul {
    li {
      color: rgba(255, 255, 255, 0.7);
      cursor: pointer;
      float: left;
      line-height: 80px;
      padding: 0 12px;
      margin: 0 20px;
      position: relative;
      &:hover {
        color: #fff;
        // .sub-nav {
        //   display: block;
        // }
        &::after {
          background: #56e3ea;
        }
      }
      &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: "";
        width: 100%;
        height: 2px;
        transition: all 0.4s;
      }
      &.active {
        color: #56e3ea;
        &::after {
          background: #56e3ea;
        }
      }
    }
  }
}
.nav-user {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  // padding: 0px 12px;
  background: url(~assets/img/main_bg.png) no-repeat -210px -195px;
  // background: url(~assets/img/main_bg.png) no-repeat -210px -221px;
}
.active {
  .nav-user {
    background: url(~assets/img/main_bg.png) no-repeat -210px -303px;
  }
}
.nav-user:hover,
.openhover {
  background-position: -210px -249px;
}
.nav-user .cur {
  background-position: -210px -275px;
}
.nav-user:active {
  background-position: -210px -195px;
}

 


</style>